export type DropDirection = "before" | "after";

export const getPointerDropDirection = (
  axis: "horizontal" | "vertical",
  clientX: number,
  clientY: number,
  rect: Pick<DOMRect, "left" | "top" | "width" | "height">,
): DropDirection => {
  if (axis === "horizontal") {
    return clientX < rect.left + rect.width / 2 ? "before" : "after";
  }

  return clientY < rect.top + rect.height / 2 ? "before" : "after";
};
